const ACCESS_REVOKED_EVENT = 'access-revoked';

export function dispatchAccessRevoked(): void {
  window.dispatchEvent(new CustomEvent(ACCESS_REVOKED_EVENT));
}

export function onAccessRevoked(handler: () => void): () => void {
  window.addEventListener(ACCESS_REVOKED_EVENT, handler);
  return () => window.removeEventListener(ACCESS_REVOKED_EVENT, handler);
}
